export default __webpack_public_path__ + "static/media/furgon-pasajeros.9ddfb316.webp";